type RouteLike = {
	path: string;
	hash?: string;
};

type SavedScrollPosition = {
	left: number;
	top: number;
};

function isShortsRoute(path: string): boolean {
	return path === '/shorts' || path.startsWith('/shorts/');
}

export default {
	scrollBehavior(
		to: RouteLike,
		from: RouteLike,
		savedPosition: SavedScrollPosition | null
	) {
		if (from.path && isShortsRoute(from.path) && to.path === '/') {
			return { left: 0, top: 0 };
		}

		if (savedPosition) return savedPosition;
		if (to.hash) return { el: to.hash };
		return { left: 0, top: 0 };
	}
};
